(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.collections-scroll-wrap').forEach(function (slider) {
      var isDown = false;
      var startX, scrollLeft;
      var velX = 0, lastX = 0, lastT = 0;
      var hasDragged = false;
      var raf;

      slider.addEventListener('mousedown', function (e) {
        cancelAnimationFrame(raf);
        isDown     = true;
        hasDragged = false;
        velX       = 0;
        startX     = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        lastX      = e.pageX;
        lastT      = Date.now();
        slider.classList.add('is-dragging');
      });

      function release() {
        if (!isDown) return;
        isDown = false;
        slider.classList.remove('is-dragging');
        coast();
      }
      slider.addEventListener('mouseup',    release);
      slider.addEventListener('mouseleave', release);

      slider.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x    = e.pageX - slider.offsetLeft;
        var walk = x - startX;
        if (Math.abs(walk) > 8) hasDragged = true;
        slider.scrollLeft = scrollLeft - walk;

        var now = Date.now();
        var dt  = now - lastT || 1;
        velX    = (e.pageX - lastX) / dt;
        lastX   = e.pageX;
        lastT   = now;
      });

      function coast() {
        if (Math.abs(velX) < 0.05) return;
        velX *= 0.92;
        slider.scrollLeft -= velX * 16;
        raf = requestAnimationFrame(coast);
      }

      slider.addEventListener('click', function (e) {
        if (hasDragged) {
          e.preventDefault();
          hasDragged = false;
        }
      }, true);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
